import AutoSelectWidget from 'forms/components/AutoSelectWidget';

const uiSchema = {
  'ui:order': [
    'status',
    'cancellationReason',
    'cancellationNote',
    '*',
  ],
  'status': {
    'ui:width': '33.33%',
  },
  'cancellationReason': {
    'ui:width': '33.33%',
  },
  'cancellationNote': {
    'ui:width': '33.33%',
  },
  'category': {
    'ui:widget': AutoSelectWidget,
  },
};

export default uiSchema;
